import React from 'react';
import {useNavigate} from "react-router-dom";
import SuccessSVG from '../../../../assets/icons/success.svg';
import FailedSVG from '../../../../assets/icons/failRed.svg';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";

const OrderStatus = (props: any) => {
    const {booking, payment } = props.order;
    const haveTime = props.haveTime;
    const navigate = useNavigate();
    const date = booking.selected_date ? booking.selected_date : false

    dayjs.extend(customParseFormat);
    dayjs.extend(utc)

    const Title = () => {
        return (
            <>
                <div className="title__date">
                    <p className="status-title">{booking?.quotation?.title}</p>
                    {date && (
                        <>
                            {
                                haveTime ? (
                                    <p className="status-selected_date">Fecha
                                        seleccionada:{dayjs.utc(date).format('DD/MM/YY HH:mm').toString()}</p>
                                ) : (
                                    <p className="status-selected_date">Fecha
                                        seleccionada: {dayjs.utc(date).format('DD/MM/YY').toString()}</p>
                                )
                            }
                        </>
                    )}
                    {SelectedOption()}
                </div>

            </>
        )
    }


    const SelectedOption = () => {
        if (booking.selected_option) {
            return (
                <p className={"status-selected_option"}>
                    Opción seleccionada: {booking.selected_option}
                </p>
            )
        }
        return (<></>)
    }

    let htmlByStatus;
    if (booking.status === "completed") {
        htmlByStatus = (
            <>
                <div className="svg-container">
                    <img src={SuccessSVG} alt="success" />
                </div>
                <h2 className="success">¡Felicitaciones por tu compra!</h2>
                <p className="identifier">
                    Número de reserva: <br/>
                    {booking.order_id}
                </p>
                <Title/>
                <p className="status-message">
                    Estamos seguros de que disfrutarás al máximo de esta nueva aventura. ¡Que tengas un viaje increíble
                    lleno de experiencias inolvidables!
                    <br/>
                    <br/>
                    ¡Buen viaje!
                </p>
                <button
                    onClick={() => navigate("/home")}
                    className="order-status-button"
                >
                    Ir al inicio
                </button>
            </>
        );
    } else if (booking.status === "cancelled") {
        htmlByStatus = (
            <>
                <div className="svg-container">
                    <img src={FailedSVG} alt="failed" />
                </div>
                <h2 className="failed">Hubo un problema con el pago</h2>
                <p className="identifier">
                    Número de referencia de pago: <br/>
                    {payment.public_id}
                </p>
                <Title/>
                <p className="status-message">
                    Lamentamos informarte que no pudimos procesar tu reserva.
                </p>
                <button
                    onClick={() => navigate("/home")}
                    className="order-status-button"
                >
                    Ir al inicio
                </button>
            </>
        );
    }

    return <div className="order-status__container">{htmlByStatus}</div>;
};

export default OrderStatus;
